import { useFamily } from '@/hooks/useFamily';
import { Family } from '@/models/Family';
import { ApplicationState } from '@/store';
import { LocaleData } from '@/translations/LocaleData';
import React from 'react';
import { useSelector } from 'react-redux';
import './styles.scss';

interface Props {
    disabled: boolean;
    familyId?: number;
    handleOnChange: (fieldName: string, families: Family[]) => void;
}

const FamilySelectionBox = ({ handleOnChange, familyId, disabled }: Props) => {
    const isAdmin: boolean = useSelector((state: ApplicationState) => state.identity.data.user.admin);

    const strings: LocaleData = useSelector((state: ApplicationState) => state.locale.data);

    const { families } = useFamily();

    const getCurrentFamily = (familyId: number) => families.filter(({ id }: Family) => id === familyId);

    const onSelectedFamily = (e: React.ChangeEvent<HTMLSelectElement>): void => handleOnChange('families', getCurrentFamily(Number(e.target.value)));

    if (!isAdmin) {
        return null;
    }

    return (
        <div className="family-selection-box-container">
            <h1 className="warning">{strings.CONTENT_FAMILY}</h1>
            <select className="form-control" disabled={disabled} name="family" onChange={onSelectedFamily} value={familyId || ''}>
                <option>{strings.SELECT_CONTENT_FAMILY}</option>

                {families?.map(({ id, name }: Family) => (
                    <option key={id} value={id}>
                        {name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default FamilySelectionBox;
